<template>
  <li class="frisbuy-fashion-list-item" @click="() => clickPostHandler()">
    <!-- TODO: make PositionBlockWrapper for not-square ShopTheLook's items -->
    <!-- <PositionBlockWrapper
      v-if="
        previewImagePositionStyles &&
        Object.keys(previewImagePositionStyles).length > 0
      "
      :x="previewImagePositionStyles.x"
      :y="previewImagePositionStyles.y"
      :scale="previewImagePositionStyles.scale / 100"
    >
      <img :src="postPreviewImage" alt="" />
    </PositionBlockWrapper> -->

    <span v-if="description" class="frisbuy-fashion-list-item__description">
      {{ description }}
    </span>

    <div
      class="frisbuy-fashion-list-item__image"
      ref="photo"
      :style="{
        'background-image': `url(${postPreviewImage}), url(${postPreviewImage})`,
        'background-repeat': 'no-repeat',
      }"
    >
      <!-- NOTE: img and aspect-ratio: inherit doesn't working in Safari -->
      <!-- <img :src="postPreviewImage" alt="" /> -->
    </div>
    <button>Подробнее</button>
  </li>
</template>

<style scoped lang="scss">
.frisbuy-fashion-list-item {
  display: flex;
  position: relative;
  flex-direction: column;

  width: 185px;
  height: 185px;

  .frisbuy-fashion-list-item__description {
    align-self: center;

    color: #2e353b;

    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 400;

    padding-bottom: 4px;
  }

  .frisbuy-fashion-list-item__image {
    width: 100%;
    height: 100%;
    background-position: top;
    background-size: cover;
  }

  // NOTE: img and aspect-ratio: inherit doesn't working in Safari
  img {
    width: 100%;
    height: auto;
    aspect-ratio: inherit;
    object-fit: cover;
  }

  button {
    position: absolute;
    right: 27px;
    bottom: 12px;

    color: #6e6e6e;
    background-color: transparent;

    border: none;
    text-decoration: underline;

    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }
}

// media queries
@media (max-width: 390px) {
  .frisbuy-fashion-list-item {
    button {
      display: none;
    }
  }
}
</style>

<script lang="ts">
import { IPostMedia, IImageCoords } from "@/gallery/interfaces";
import { PropType, defineComponent } from "vue";

export default defineComponent({
  emits: {
    click: null,
  },

  props: {
    postMedia: {
      type: Object as PropType<IPostMedia>,
      required: true,
    },

    description: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      isHighResImage: true,
    };
  },

  computed: {
    postPreviewImage(): string {
      if (this.isHighResImage) {
        return this.postMedia.imageUrl;
      } else {
        return this.postMedia.thumbnailUrl;
      }
    },

    previewImagePositionStyles(): IImageCoords | undefined {
      if (!this.postMedia || !this.postMedia.view) {
        return undefined;
      }

      const { preview } = this.postMedia.view;

      if (!preview) {
        return undefined;
      }

      return preview;
    },
  },

  methods: {
    clickPostHandler() {
      this.$emit("click");
    },
  },
});
</script>
